import { awsConfig } from "../config";
import type {
  CalculatorInput,
  CalculationKind,
  CalculationResult,
} from "../engine";

export interface SavedCalculation {
  id: string;
  title: string;
  kind: CalculationKind;
  input: CalculatorInput;
  result: CalculationResult;
  createdAt: string;
  updatedAt: string;
}

async function request<T>(
  path: string,
  token: string,
  init: RequestInit = {},
): Promise<T> {
  const response = await fetch(`${awsConfig.apiUrl}${path}`, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...init.headers,
    },
  });
  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as {
      message?: string;
    } | null;
    throw new Error(body?.message || "No fue posible completar la solicitud.");
  }
  if (response.status === 204) return undefined as T;
  return (await response.json()) as T;
}

export const calculationsApi = {
  list: (token: string) =>
    request<{ items: SavedCalculation[] }>("/calculations", token),
  create: (
    token: string,
    payload: Omit<SavedCalculation, "id" | "createdAt" | "updatedAt">,
  ) =>
    request<SavedCalculation>("/calculations", token, {
      method: "POST",
      body: JSON.stringify(payload),
    }),
  remove: (token: string, id: string) =>
    request<void>(`/calculations/${encodeURIComponent(id)}`, token, {
      method: "DELETE",
    }),
  deleteAccount: (token: string) =>
    request<void>("/account", token, { method: "DELETE" }),
};

